import { getConfig } from '../ConfigurationService';
import { Configuration } from '../ConfigurationService/ConfigurationService';

export enum LocalStorageKey {
  AutomaticRemindersComplianceNoticeHidden = 'automatic_reminders_compliance_notice_hidden',
  IntroStatesCollapsedIntroStates = 'introStates.collapsedIntroStates',
  InvoicingExportType = 'invoicing_export_type',
  CreditNoteExportType = 'creditnote_export_type',
  ExportFieldsData = 'export_fields_data',
  QuotationsHeaderCollapsed = 'quotations_header_collapsed',
  QuotationsHeaderFields = 'quotations_header_fields',
  QuotationsExpiryBannersDismissed = 'quotations_expiry_banners_dismissed',
  ProjectHeaderCollapsed = 'project_header_collapsed',
  ProjectDetailCollapsibles = 'project_detail_collapsibles',
  ProjectTaskDetailCollapsibles = 'project_task_detail_collapsibles',
  ProjectGroupDetailCollapsibles = 'project_group_detail_collapsibles',
  ProjectMaterialDetailCollapsibles = 'project_material_detail_collapsibles',
  ProjectMeetingDetailCollapsibles = 'project_meeting_detail_collapsibles',
  ProjectsOverviewSmartFilters = 'projects_overview_smart_filters',
  ProjectsTimelineView = 'projects_timeline_view',
  DashboardWidgets = 'dashboard_widgets',
  DealsSelectedPipelineFilter = 'deals_selected_pipeline_filter',
  CompanyInformationWidgetFullWidth = 'company_information_widget_full_width',
  PlanningComingSoonHidden = 'planning_coming_soon_hidden',
  PlanningShowWeekendsPreference = 'planning_show_weekends_preference',
  PlanningDisplayedCardInfoPreference = 'planning_displayed_card_info_preference',
}

const generateAccountAndEmployeeIdPrefix = () =>
  `${getConfig(Configuration.AccountId)}_${getConfig(Configuration.EmployeeId)}`;

export const generateLocalStorageWidgetKey = (context: string, label: string, id: string) => {
  if (context === 'company') {
    return `company_detail_${label.replace(' ', '-')}_${id}_widget_expanded`;
  }
};

export const getPreferenceFromLocalStorageForCurrentUser = (key: string, defaultValue?: any) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    const foundValue = localStorage.getItem(`${prefix}_${key}`);
    const parsedValue = foundValue && JSON.parse(foundValue);
    if (parsedValue === null) {
      return defaultValue;
    }
    return parsedValue;
  } catch (exception) {
    // localStorage not available
    return defaultValue;
  }
};

export const savePreferenceToLocalStorageForCurrentUser = (key: string, value: any) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    localStorage.setItem(`${prefix}_${key}`, JSON.stringify(value));
  } catch (exception) {
    // localStorage not available or QuotaExceededError
  }
};

export const removePreferenceFromLocalStorageForUser = (key: string) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    localStorage.removeItem(`${prefix}_${key}`);
  } catch (exception) {
    // localStorage not available
  }
};
